// material-ui

import changeplandepartmenticon from '../../../assets/images/change-plan.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const ChangePlanDepartmentIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={changeplandepartmenticon} alt="Change Plan Department" width="22"  />
    );
};

export default ChangePlanDepartmentIcon;
